import { useTranslation } from 'react-i18next';

export default function ProcessSection() {
  const { t } = useTranslation('common');

  const steps = [
    {
      number: '01',
      title: t('process.step1.title'),
      description: t('process.step1.description'),
      icon: 'ri-search-line'
    },
    {
      number: '02',
      title: t('process.step2.title'),
      description: t('process.step2.description'),
      icon: 'ri-code-s-slash-line'
    },
    {
      number: '03',
      title: t('process.step3.title'),
      description: t('process.step3.description'),
      icon: 'ri-rocket-line'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            {t('process.title')}
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {steps.map((step, index) => (
            <div
              key={index}
              className="relative bg-gray-50 rounded-lg p-8 hover:shadow-lg transition-shadow duration-300"
            >
              <div className="flex items-center justify-center w-16 h-16 bg-teal-500 text-white rounded-full mb-6 mx-auto">
                <i className={`${step.icon} text-2xl`}></i>
              </div>
              <div className="absolute top-4 right-4 text-5xl font-bold text-gray-200">
                {step.number}
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3 text-center">
                {step.title}
              </h3>
              <p className="text-gray-600 text-center leading-relaxed">
                {step.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}